import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	viewAllProjects: {
		id: 'navigation-apps-sidebar-nav4-sidebars-content-projects-core.common.footer.view-all-projects',
		defaultMessage: 'View all projects',
		description: 'Message for the view all projects menu item in the projects submenu',
	},
});
